module.exports = __webpack_public_path__ + "static/img/product_banner_16_zh.9feb8ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_16_zh.png
// module id = v+iS
// module chunks = 34